import PointItem from './PointItem';

export default function PointsPanel({
  points = [],
  editable = false,
  reordering = false,
  onEdit,
  onDelete,
  onMove,
  emptyMessage = 'No points yet. Develop this idea to start building them.',
}) {
  if (!points.length) {
    return (
      <p className="text-sm text-gray-400 dark:text-gray-500 italic py-2">
        {emptyMessage}
      </p>
    );
  }

  return (
    <ul className="space-y-1">
      {points.map((point) => (
        <PointItem
          key={point.id}
          point={point}
          editable={editable}
          reordering={reordering}
          onEdit={onEdit}
          onDelete={onDelete}
          onMove={onMove}
        />
      ))}
    </ul>
  );
}
